import React, { useState } from 'react';
import { InteractiveMap } from './InteractiveMap/InteractiveMap';
import { StaticMap } from './StaticMap/StaticMap';

const DEFAULT_ZOOM = 13;

interface Props {
  location: { latitude: number; longitude: number };
  gMapsApiKey: string;
}

export const Map: React.FC<Props> = ({ location, gMapsApiKey }) => {
  const [showStaticMap, setShowStaticMap] = useState(true);

  if (showStaticMap) {
    return <StaticMap onClick={() => setShowStaticMap(false)} />;
  }

  return <InteractiveMap location={location} gMapsApiKey={gMapsApiKey} mapZoom={DEFAULT_ZOOM} />;
};
